angular.module('GatorPad.controllers.Logout', [])

  .controller('LogoutController', ['$rootScope', '$location', 'ApiService', function ($rootScope, $location, ApiService) {
    
  $rootScope.sessionData = null;
  ApiService.resetLocalStorage(true);

  $location.path("/");    
}]);